<template>
    <div>
        <el-menu :default-active="itemVal" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="0">财务统计</el-menu-item>
            <el-menu-item index="1">财务数据</el-menu-item>
        </el-menu>
        <div style='margin-top:30px'></div>
        <div class="line"></div>
        <v-content0 v-if="itemVal==='0'"></v-content0>
        <v-content1 v-if="itemVal==='1'"></v-content1>
    </div>
</template>

<script>
import $ from 'jquery';
import vContent0 from './FinanceStatistics.vue';
import vContent1 from './FinanceData.vue';
export default {

    data() {
        return {
            itemVal:'0',
        };
    },
    created() {

    },
    //页面加载方法
    mounted: function () {

    },
    components: {
        vContent0,
        vContent1
    },

    methods: {
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
};
</script>

<style scoped>
</style>
